<div v-if="load_error || save_success" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
    <div v-if="load_error" class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-error" role="alert">
        <div class="d-flex align-items-center gap-3 p-3">
        <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
            <i class="bi bi-exclamation-circle"></i>
        </span>
        <div class="toast-body p-0 fw-semibold lh-sm">{{ load_error }}</div>
        <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_error"></button>
        </div>
    </div>

    <div v-if="save_success" class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-success" role="status">
        <div class="d-flex align-items-center gap-3 p-3">
        <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
            <i class="bi bi-check2-circle"></i>
        </span>
        <div class="toast-body p-0 fw-semibold lh-sm">{{ save_success }}</div>
        <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_success"></button>
        </div>
    </div>
</div>
